import { render, staticRenderFns } from "./BlogArticlesFilterByTags.vue?vue&type=template&id=18e85ea8"
import script from "./BlogArticlesFilterByTags.vue?vue&type=script&lang=js"
export * from "./BlogArticlesFilterByTags.vue?vue&type=script&lang=js"
import style0 from "./BlogArticlesFilterByTags.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports